module.exports = __webpack_public_path__ + "img/aasb-logo.d0bf795f.png";